
import common_mt from "./common_mt";
import {Toast} from 'vant';
import common from "../js/common";
import md5 from "js-md5";
import {formatData} from "../js/utils";
import {get, post} from "../js/http";

export function getMeituanPid(paramsData, fn){
    let _uid = paramsData.uid;
    if(_uid){
        let randomNum = common.getRandom();
        let _md5 = md5(randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData, 'canNull');
        this.$log(param);
        let url = common_mt.regist_meituan_pid;

        post(url, param).then(function (response) {
            if (fn) {
                fn(response);
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 用户可提款金额
 * @param paramsData
 * @param fn
 */
export function getUserPayTo_mt(paramsData, fn) {
    let spid = paramsData.uid;
    if (spid) {
        let randomNum = common.getRandom();
        let _md5 = md5(spid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);

        let url = common_mt.user_pay_to + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        })
    }
}

/**
 * 用户可提款明细
 * @param paramsData
 * @param fn
 */
export function getUserPayList_mt(paramsData, fn) {
    let uid = paramsData.uid;
    if (uid) {
        let randomNum = common.getRandom();
        let _md5 = md5(uid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);

        let url = common_mt.user_pay_list + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        })
    }
}

/**
 * 代理通过下级和下下级所能获得的佣金提成的集合
 * @param paramsData
 * @param fn
 */
export function getPidLevelCountList_mt(paramsData, fn) {
    let u_mark = paramsData.u_mark;
    if (u_mark) {
        let randomNum = common.getRandom();
        let _md5 = md5(u_mark + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);

        let url = common_mt.pid_level_count_list + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 获取每日预估收入的列表
 * @param paramsData
 * @param fn
 */
export function getEverydayCountList_mt(paramsData, fn) {
    // uid:群号 必须
    // stime:开始时间 默认当天
    // etime:结束时间  默认当天
    let uid = paramsData.uid;
    if (uid) {
        let randomNum = common.getRandom();
        let _md5 = md5(uid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;
        let param = formatData(paramsData);
        let url = common_mt.get_everyday_count_list + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 群下级人数及收入
 * @param paramsData
 * @param fn
 */
export function getLevelCountData_mt(paramsData, fn) {

    let uid = paramsData.uid;
    if (uid) {
        let randomNum = common.getRandom();
        let _md5 = md5(uid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;
        let param = formatData(paramsData);
        let url = common_mt.level_count_data + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        })
    }
}

/**
 * 获取订单列表(完成时间)
 * @param paramsData
 * @param fn
 */
export function getOrderByFinish_mt(paramsData, fn) {

    let pid = paramsData.pid;
    if (pid) {
        let randomNum = common.getRandom();
        let _md5 = md5(pid + randomNum + common.key).toLowerCase();
        this.$log("md5 --- " + _md5)
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData, 'canNull');
        this.$log(param);
        let url = common_mt.get_order_by_Finish + "?" + param;

        get(url).then(function (response) {
            if (fn) {
                fn(response);
            }
        })
    }
}

/**
 * 订单详情下载xls
 * @param paramsData
 * @param fn
 */
export function getOrderByFinishXls_mt(paramsData, fn) {
    let pid = paramsData.pid;
    let stime = paramsData.stime;

    if (pid && stime) {
        let randomNum = common.getRandom();
        let _md5 = md5(pid + stime + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);

        let url = common_mt.get_order_by_finish_xls;

        post(url, param).then(function (response) {
            if (fn) {
                fn(response);
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 获取提款纪录
 * @param paramsData
 * @param fn
 */
export function getOrderBySumbit_mt(paramsData, fn) {
    let uid = paramsData.uid;

    if (uid) {
        let randomNum = common.getRandom();
        let _md5 = md5(uid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);

        let url = common_mt.get_order_by_sumbit;

        post(url, param).then(function (response) {
            if (fn) {
                fn(response);
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 收入统计接口
 * @param paramsData
 * @param fn
 */
export function getIncometByData_mt(paramsData, fn) {
    // pid:推荐位ID 必须
    // stime:开始时间 默认当天
    // etime:结束时间  默认当天
    let spid = paramsData.pid;
    if (spid) {
        let randomNum = common.getRandom();
        let _md5 = md5(spid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;
        let param = formatData(paramsData);
        let url = common_mt.order_count_new + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        })
    }
}

/**
 * 获取系统配置
 * @param paramsData
 * @param fn
 */
export function getSubConfig_mt(fn) {

    let randomNum = common.getRandom();
    let _md5 = md5(randomNum + common.key).toLowerCase();
    let paramsData = {
        md5: _md5,
        rnum: randomNum
    };

    let param = formatData(paramsData);
    this.$log("getSubConfig param = " + param)
    let url = common_mt.sub_config + '?' + param;
    get(url).then(function (response) {
        if (fn) {
            fn(response)
        }
    })
}

/**
 * 获取订单列表
 * @param paramsData
 * @param fn
 */
export function getOrderList_mt(paramsData, fn) {

    let pid = paramsData.pid;
    if(pid){
        let randomNum = common.getRandom();
        let _md5 = md5(pid + randomNum + common.key).toLowerCase();
        this.$log("md5 --- " + _md5)
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData, 'canNull');
        this.$log(param);
        let url = common_mt.get_order_list + "?" + param;

        get(url).then(function (response) {
            if (fn) {
                fn(response);
            }
        })
    }else{
        Toast.fail({
            message: 'pid为空'
        })
        if (fn) {
            fn(null);
        }
    }
}